/*
* @Author: zhengxiaowen
* @Date: 2018-08-21 11:50:06
* @Last Modified by: zhengxiaowen
* @Last Modified time: 2019-04-25 10:27:36
*/

import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import store from '@/common/store/StoreCommon'

import nativeApi from '@/common/tool/nativeApi'
import systemHook from '@/config/systemHook'

import moment from 'moment'
import md5 from 'vux/src/tools/md5/index.js'



axios.defaults.timeout = 30000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'




axios.interceptors.response.use((res) => {
if (res.data.status === 'timeout') {
nativeApi.nativeFN.logout()
}
if (res.data.status && res.data.status !== 'S' && res.data.status !== 'D' && res.data.status !== 'M') {

return Promise.reject(res.data, {})
}
return res 
}, (err) => {
let errMsg = ''

if (err && err.response) {
switch (err.response.status) {
case 400:
errMsg = '错误请求'
break
case 401:
errMsg = '未授权，请重新登录'
break
case 403:
errMsg = '拒绝访问'
break
case 404:
errMsg = '请求错误,未找到该资源'
break
case 405:
errMsg = '请求方法未允许'
break
case 408:
errMsg = '请求超时'
break
case 500:
errMsg = '服务器端出错'
break
case 501:
errMsg = '网络未实现'
break
case 502:
errMsg = '网络错误'
break
case 503:
errMsg = '服务不可用'
break
case 504:
errMsg = '网络超时'
break
case 505:
errMsg = 'http版本不支持该请求'
break
default:
errMsg = `连接错误${err.response.status}`
}
} else {
errMsg = '服务器没响应'
}
return Promise.reject({ msg: errMsg, status: 'E' })
})

let fetch = {
postAlert: (url, params = {}, v = null) => {
Vue.$vux.loading.show()
return new Promise((resolve, reject) => {
fetch.postSimpleness(url, params, v).then(res => {
resolve(res)
Vue.$vux.loading.hide()
}).catch(error => {
Vue.$vux.loading.hide()
Vue.$vux.alert.show({
title: '提示',
content: error.msg,
onShow() {
},
onHide() {
}
})
reject(error, {})
})
})
},
post: (url, params = {}, v = null) => {
Vue.$vux.loading.show()
return new Promise((resolve, reject) => {
fetch.postSimpleness(url, params, v).then(res => {
resolve(res)
Vue.$vux.loading.hide()
}).catch(error => {
Vue.$vux.loading.hide()
Vue.$vux.toast.show({
type: 'warn',
text: error.msg
})
reject(error, {})
})
})
},


postSimpleness: (url, params = {}, v = null) => {

return new Promise((resolve, reject) => {
fetch.postBasics(url, params, v).then(res => {
resolve(res)
}).catch(error => {
reject(error, {})
})
})

},



postV1: (url, params = {}) => {
Vue.$vux.loading.show()
return new Promise((resolve, reject) => {
fetch.postSimplenessV1(url, params).then(res => {
resolve(res)
Vue.$vux.loading.hide()
}).catch(error => {
Vue.$vux.loading.hide()
Vue.$vux.toast.show({
type: 'warn',
text: error.msg
})
reject(error, {})
})
})
},


postSimplenessV1: (url, params = {}) => {

return new Promise((resolve, reject) => {
fetch.postBasics(url, params, "v1").then(res => {
resolve(res)
}).catch(error => {
reject(error, {})
})
})

},

postBasics: (url, params = {}, v) => {

let headers = systemHook.getHeaders()

if (!v) {

if (url.indexOf('/v2/file/upload') != -1) {
v = "v2"
} else {
v = "v1"
}
}

if (v === "v0") {
headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
if (systemHook && systemHook.PostParams) {
params.params = Object.assign(systemHook.PostParams(), params.params)
}
params.params = params.params ? JSON.stringify(params.params) : JSON.stringify({})
params = qs.stringify(params)
} else if (v === "v1") {
headers['Content-Type'] = 'application/json;charset=UTF-8'
if (systemHook && systemHook.PostParams) {
params = Object.assign(systemHook.PostParams(), params)
}
} else if (url.indexOf("/v2/file/upload") >= 0) {

headers['Content-Type'] = 'application/x-www-form-urlencoded'
} else if (v === "v2") {
headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
params = ((data) => {
const formdata = new FormData();
Object.keys(data).forEach(key => formdata.append(key, data[key]));
return formdata;
})(params)
}

return new Promise((resolve, reject) => {

systemHook.setParamsSignature(headers, params)

let _responseType = null
let _streamUrlList = systemHook.streamUrlList
if (!!_streamUrlList && _streamUrlList.length > 0) {
for (let i = 0; i < _streamUrlList.length; i++) {
let _reg = new RegExp(_streamUrlList[i])
if (_reg.test(url)) {
_responseType = "arraybuffer"
break;
}
}
}
let _config = {
headers: headers
}
if (_responseType !== null) {
_config["responseType"] = _responseType
}
axios.post(url, params, _config)
.then(response => {
resolve(response.data)
})
.catch(error => {
reject(error)
})
}).catch((error) => {
return Promise.reject(error, {})
})
},
get: (url, params = {}, v = null) => {



return new Promise((resolve, reject) => {
fetch.getSimpleness(url, params, {}).then(res => {
resolve(res)

}).catch(error => {


reject(error, {})
})
})
},

getSimpleness: (url, params = {}, v = null) => {
return new Promise((resolve, reject) => {
fetch.getBasics(url, params).then(res=>{
resolve(res)
}).catch(error=>{
reject(error, {})
})
})

},
getBasics: (url, params = {}, v) => {

let headers = systemHook.getHeaders()
headers['Content-Type'] = 'application/json;charset=UTF-8'
return new Promise((resolve, reject) => {
axios.get(url,{
headers: headers,
timeout: 1000 * 60 * 10,
params:params
}).then(response => {
resolve(response.data)
}).catch(error => {
reject(error)
})
}).catch((error) => {
return Promise.reject(error, {})
})
}
}

export default fetch



// WEBPACK FOOTER //
// ./src/common/tool/fetchTool.js